var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "onboarding-layout" }, [
    _c("div", { staticClass: "onboarding-left" }, [
      _c(
        "div",
        {
          staticClass: "onboarding-progress-container",
          style: { visibility: _vm.showProgress ? "visible" : "hidden" },
        },
        [
          _c("div", { staticClass: "onboarding-progress-bar" }, [
            _c("div", {
              staticClass: "onboarding-progress-fill",
              style: { width: _vm.progressBar1 + "%" },
            }),
          ]),
          _c("div", { staticClass: "onboarding-progress-bar" }, [
            _c("div", {
              staticClass: "onboarding-progress-fill",
              style: { width: _vm.progressBar2 + "%" },
            }),
          ]),
        ]
      ),
      _c("div", { staticClass: "onboarding-content" }, [
        _c("div", { staticClass: "onboarding-title-section" }, [
          _c("h1", { staticClass: "onboarding-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm.subtitle
            ? _c("p", { staticClass: "onboarding-subtitle" }, [
                _vm._v(_vm._s(_vm.subtitle)),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "onboarding-step-content" },
          [_vm._t("default")],
          2
        ),
        _c("div", { staticClass: "onboarding-navigation" }, [
          _vm.showSkipButton
            ? _c(
                "button",
                {
                  staticClass: "onboarding-btn onboarding-btn-skip",
                  on: { click: _vm.handleSkip },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.skipButtonLabel || _vm.$t("onboarding.common.skip")
                      ) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "onboarding-btn onboarding-btn-next",
              class: { disabled: !_vm.canProceed },
              attrs: { disabled: !_vm.canProceed },
              on: { click: _vm.handleNext },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.computedNextButtonLabel) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "onboarding-right" }, [
      _c("div", {
        staticClass: "onboarding-image",
        style: {
          backgroundImage:
            "url(" + require("@/assets/img/carousel/login_carousel.webp") + ")",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }